import { render, staticRenderFns } from "./PutAwayForm.vue?vue&type=template&id=773f74de"
import script from "./PutAwayForm.vue?vue&type=script&lang=js"
export * from "./PutAwayForm.vue?vue&type=script&lang=js"
import style0 from "./PutAwayForm.vue?vue&type=style&index=0&id=773f74de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports